import { TiltifyOAuthButton } from './tiltify-oauth-button.jsx';
import PropTypes from 'prop-types';
import { useState } from 'preact/hooks';
import useTiltifyConfig from '@hooks/useTiltifyConfig.js';
import Button from '@components/buttons/button.jsx';
import { isTestMode } from '@util/const.js';

TiltifySetup.propTypes = {
  onSignIn: PropTypes.func,
  onSignOut: PropTypes.func,
};

export default function TiltifySetup({
  onSignIn = ({ userID, username }) => {
    console.warn('onSignIn not handled', userID, username);
  },
  onSignOut = () => console.warn('onSignOut not handled'),
}) {
  const config = useTiltifyConfig();
  const tiltifyUsername =
    config.tiltifyUsername || localStorage.getItem('tiltifyUsername');
  const tiltifyUserSlug =
    config.tiltifyUserSlug || localStorage.getItem('tiltifyUserSlug');

  const [isTiltifySetup, setTiltifySetup] = useState(
    tiltifyUsername !== null &&
      tiltifyUsername.length > 0 &&
      tiltifyUserSlug !== null &&
      tiltifyUserSlug.length > 0
  );

  function logoutTiltify() {
    config.tiltifyUserSlug = '';
    config.tiltifyUsername = '';
    config.tiltifyUserID = '';
    config.tiltifyCampaignID = '';
    config.tiltifyPollID = '';
    config.tiltifyCampaignSlug = '';
    config.tiltifyCampaignGoal = '';
    config.tiltifyCampaignName = '';

    localStorage.removeItem('tiltifyUserSlug');
    localStorage.removeItem('tiltifyUsername');
    localStorage.removeItem('tiltifyUserID');
    localStorage.removeItem('tiltifyCampaignSlug');
    localStorage.removeItem('tiltifyCampaignID');
    localStorage.removeItem('tiltifyPollID');
    localStorage.removeItem('tiltifyCampaignGoal');
    localStorage.removeItem('tiltifyCampaignName');

    setTiltifySetup(false);
    onSignOut();
  }

  if (!isTiltifySetup)
    return (
      <TiltifyOAuthButton
        setTiltifyUser={(user) => {
          config.tiltifyUserSlug = user.slug;
          config.tiltifyUserID = user.id;
          config.tiltifyUsername = user.username;
          localStorage.setItem('tiltifyUserID', user.id);
          localStorage.setItem('tiltifyUsername', user.username);
          localStorage.setItem('tiltifyUserSlug', user.slug);
          setTiltifySetup(
            config.tiltifyUsername.length > 0 &&
              config.tiltifyUserSlug.length > 0 &&
              config.tiltifyUserID.length > 0
          );
          onSignIn({
            userID: user.id,
            username: user.username,
            slug: user.slug,
          });
        }}
      />
    );
  else
    return (
      <div className="flex flex-col">
        <div className="flex items-center justify-between">
          <article className="prose text-sm">
            Your Tiltify account,{' '}
            <b>{isTestMode ? 'Test User' : config.tiltifyUsername}</b>, has been
            connected
          </article>
          <Button
            style="secondary"
            mode="button"
            disabled={isTestMode}
            onClick={logoutTiltify}
            size="small"
          >
            Sign Out
          </Button>
        </div>
      </div>
    );
}
